import React from "react";
import BirthdayScreen from "../../Birthday";

const Screen33 = () => {
    return <BirthdayScreen />;
};

export default Screen33;
